import { api } from "@/api/axios.ts";
import {
  ApiFormTemplateFolder,
  ApiFormTemplateFolderPayload,
  TemplateFolderModule,
} from "@/types/forms/form-template-folder.types.ts";

export const apiTemplateFolders = {
  getAll: (module: TemplateFolderModule, signal?: AbortSignal) =>
    api.get<ApiFormTemplateFolder[]>(`/api/v1/${module}/template-folders`, undefined, signal),
  create: (module: TemplateFolderModule, payload: ApiFormTemplateFolderPayload) =>
    api.post<ApiFormTemplateFolder>(`/api/v1/${module}/template-folders`, payload),
  update: (module: TemplateFolderModule, id: number, payload: ApiFormTemplateFolderPayload) =>
    api.put<ApiFormTemplateFolder>(`/api/v1/${module}/template-folders/${id}`, payload),
  delete: (module: TemplateFolderModule, id: number) =>
    api.delete(`/api/v1/${module}/template-folders/${id}`),
};
